import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["bio", "readMore"]

  connect() {
    this.active = false
    document.addEventListener("click", this.handleOutsideClick.bind(this))
  }

  disconnect() {
    document.removeEventListener("click", this.handleOutsideClick.bind(this))
  }

  toggle(event) {
    if (window.matchMedia("(hover: none)").matches) {
      event.preventDefault()
      this.active = !this.active
      this.updateUI()
    }
  }

  handleOutsideClick(event) {
    if (this.active && !this.element.contains(event.target)) {
      this.active = false
      this.updateUI()
    }
  }

  updateUI() {
    if (this.active) {
      this.bioTarget.classList.add("translate-y-0")
      this.bioTarget.classList.remove("translate-y-full")
      this.readMoreTarget.classList.add("opacity-0")
    } else {
      this.bioTarget.classList.remove("translate-y-0")
      this.bioTarget.classList.add("translate-y-full")
      this.readMoreTarget.classList.remove("opacity-0")
    }
  }
}
